var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 7,
    viewBox: "0 0 13 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.22221 4.93301L10.8562 0.464648C11.1992 0.13418 11.7538 0.13418 12.0932 0.464648C12.4325 0.795116 12.4325 1.32949 12.0932 1.65996L6.84251 6.72246C6.51047 7.04238 5.97774 7.04942 5.63475 6.74707L0.347582 1.66348C0.176086 1.49824 0.0921631 1.28027 0.0921631 1.06582C0.0921631 0.851367 0.176086 0.633398 0.347582 0.468164C0.690572 0.137695 1.2452 0.137695 1.58454 0.468164L6.22221 4.93301Z",
    fill: "#646168",
    fillOpacity: 0.501961
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.23334f14859188a9e71f0405eec02d0c.svg";
export { ForwardRef as ReactComponent };